import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import {
  FORM_APP,
  WIX_BLOG,
  WIX_BOOKINGS,
  WIX_EVENTS,
  WIX_NEW_STORES,
  WIX_PORTFOLIO,
  WIX_RESTAURANTS_MENUS_NEW,
} from '@wix/app-definition-ids'

import { defaultCategory } from '../../../category/defaultCategory'

export type BusinessTermEntry = {
  businessTerm: BusinessTerm
  businessSegmentId?: string
  appDefId?: string
}

const bookingsBusinessTermEntry: BusinessTermEntry = {
  businessTerm: {
    displayName: 'Consultant',
    industryId: 'e63a7a733552db1fda364af7',
    structureId: '28e95344ac1c3b2a8f8b4cdc',
    businessTermId: '5c9780c4-39bd-43c2-8448-7d3bead71cf4',
    postRegVertical: 'business',
  },
  businessSegmentId: 'business-professionals',
  appDefId: WIX_BOOKINGS,
}

export const businessTermMap: Record<string, BusinessTermEntry> = {
  store: {
    businessTerm: {
      displayName: 'Online Store',
      industryId: '087d714d5f85b09c65b51e28',
      structureId: '073bd83d054dcff87fa0ef50',
      businessTermId: '6569ce47-806c-4a25-8000-03b0d8a79360',
      postRegVertical: 'online-store',
    },
    businessSegmentId: 'consumer-stores',
    appDefId: WIX_NEW_STORES,
  },
  bookings: bookingsBusinessTermEntry,
  sell_services: bookingsBusinessTermEntry,
  blog: {
    businessTerm: {
      displayName: 'Blog',
      industryId: '746ec6a2d8702cc571ceb700',
      structureId: 'b0a520919b99728bae200018',
      businessTermId: 'fe2100bb-6a16-47e4-bed8-2c682a97ab14',
      postRegVertical: 'blog',
    },
    businessSegmentId: 'blog-content',
    appDefId: WIX_BLOG,
  },
  portfolio: {
    businessTerm: {
      displayName: 'Portfolio',
      industryId: '274536fb36fab46dce7e34a1',
      structureId: 'a28c5e5ea1945e5fa4ca1728',
      businessTermId: '2c97c0d6-ac44-4fc1-bc31-3f870d7999ce',
      postRegVertical: 'portfolio-cv',
    },
    businessSegmentId: 'portfolio',
    appDefId: WIX_PORTFOLIO,
  },
  form: {
    businessTerm: {
      displayName: defaultCategory.displayName,
      industryId: defaultCategory.industryId,
      structureId: defaultCategory.structureId,
      businessTermId: defaultCategory.businessTermId,
      postRegVertical: defaultCategory.postRegVertical,
    },
    businessSegmentId: defaultCategory.businessSegmentId,
    appDefId: FORM_APP,
  },
  restaurant: {
    businessTerm: {
      displayName: 'Restaurant',
      industryId: 'f9b2c722c83ab893929ddd3f',
      structureId: 'd87632e3733a0aa8ead89d05',
      businessTermId: 'eccac35b-9660-4404-88dd-d393c9b2b306',
      postRegVertical: 'restaurants-food',
    },
    businessSegmentId: 'restaurants',
    appDefId: WIX_RESTAURANTS_MENUS_NEW,
  },
  collect_rsvp: {
    businessTerm: {
      displayName: 'Event Invitation',
      industryId: 'fc0d853bdbb9639040696379',
      structureId: '7f46632f92b9f8f5c1afa658',
      businessTermId: '3d89d43c-069b-44d2-af85-c4fe88870d17',
      postRegVertical: 'events',
    },
    businessSegmentId: 'public-events',
    appDefId: WIX_EVENTS,
  },
  other: {
    businessTerm: {
      displayName: defaultCategory.displayName,
      industryId: defaultCategory.industryId,
      structureId: defaultCategory.structureId,
      businessTermId: defaultCategory.businessTermId,
      postRegVertical: defaultCategory.postRegVertical,
    },
    businessSegmentId: defaultCategory.businessSegmentId,
  },
}
